import request from '../httpClient';
// import * as Chance from 'chance';
// import {camelizeKeys} from 'humps';
import { AirbnbCodeVerification } from '../../models/airbnbAuthModel';

// const chance = new Chance();

enum AirbnbAuthEndpoints {
  Login = '/integration/airbnb/login',
  RequestVerificationCode = '/integration/airbnb/send_or_verify_code',
  VerifyCode = '/integration/airbnb/send_or_verify_code'
}

export const loginToAirbnb = (teamId: number, email: string, password: string) =>
  request.post(String(AirbnbAuthEndpoints.Login), { teamId, email, password });

// const doneResponse = {accountId: '234'};

// const codeVerificationResponse = {
//   is_code_verification: true,
//   user_id: 1415,
//   airlock_id: 15712,
//   friction_data: [
//     {
//       friction: 'email_code_verification',
//       hint_text: 'Send verify code to doan****.mobi'
//     },
//     {
//       friction: 'phone_verification_via_text',
//       phone_numbers: [
//         {
//           id: 123441,
//           hint_text: 'Send verify code to +8445****09'
//         }
//       ]
//     }
//   ],
//   access_token: 'atoken'
// };

// const redirectResponse = {
//   is_redirect: true,
//   airlock_id: 12451,
//   link_redirect: 'https://www.airbnb.com'
// };

// export const loginToAirbnb = (email: string, password: string) => {
//   let data;

//   switch (chance.d4()) {
//     case 1:
//       data = doneResponse;
//       break;
//     case 2:
//       data = redirectResponse;
//       break;
//     default:
//       data = codeVerificationResponse;
//   }

//   return Promise.resolve({status: 200, data: camelizeKeys(data)});
// };

// export const requestAirbnbVerificationCode = (method: AirbnbCodeVerification) => {
//   return Promise.resolve({status: 200});
// };

// export const verifyAirbnbCode = (method: AirbnbCodeVerification, code: string) => {
//   let status;

//   if (chance.coin() === 'heads') {
//     status = 200;
//   } else {
//     status = 400;
//   }

//   return Promise.resolve({status});
// };

export const requestAirbnbVerificationCode = async (method: AirbnbCodeVerification) => {
  const { airlockId, userId, accessToken, friction } = method;

  return await request.post( //
    String(AirbnbAuthEndpoints.RequestVerificationCode),
    { airlockId, userId, accessToken, friction }
  );
};

export const verifyAirbnbCode = async (method: AirbnbCodeVerification, code: string) => {
  const { airlockId, userId, accessToken, friction } = method;

  return await request.post(String(AirbnbAuthEndpoints.VerifyCode), { airlockId, userId, accessToken, friction, code });
};



// WEBPACK FOOTER //
// ./src/services/api/airbnbAuthApi.ts